import useTracker from '/druid/useTracker';

const Tracker: React.FC<{}> = () => {
  useTracker();

  return null;
};

export default Tracker;
